import { render, staticRenderFns } from "./SoftwarePartnerRow.vue?vue&type=template&id=77c527ef"
import script from "./SoftwarePartnerRow.vue?vue&type=script&lang=js"
export * from "./SoftwarePartnerRow.vue?vue&type=script&lang=js"
import style0 from "./SoftwarePartnerRow.vue?vue&type=style&index=0&id=77c527ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports